import { Link } from 'react-router-dom';
import { danmakuList } from '@/mocks/danmaku';

const stats = [
  { label: '收录名场面', value: '341+' },
  { label: '今日热评', value: '2.6万' },
  { label: '玩梗关键词', value: '1200+' },
];

export default function HeroSection() {
  const tickerItems = [...danmakuList, ...danmakuList];

  return (
    <section className="relative flex min-h-[560px] items-center overflow-hidden md:min-h-[700px]">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20energetic%20collage%20of%20glowing%20coral%20orange%20and%20amber%20gold%20light%20streaks%20over%20a%20deep%20warm%20brown%20background%2C%20dynamic%20motion%20blur%20particles%20and%20neon%20spark%20trails%2C%20bold%20modern%20digital%20art%2C%20high%20contrast%2C%20vibrant%20playful%20mood%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=tangxin-hero-01&orientation=landscape"
        alt="充满活力光晕与火花轨迹的抽象背景，代表热闹的玩梗现场"
        title="糖心吃瓜 玩梗现场"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-transparent" />

      <div className="relative z-10 w-full">
        <div className="mx-auto max-w-content px-4 pb-16 pt-28 md:px-6 md:pb-20 md:pt-32">
          <span className="inline-flex flex-wrap items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur-sm md:text-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-soft" />
            热评 · 弹幕 · 名场面 · 群聊高能
          </span>

          <h2 className="mt-5 max-w-3xl text-4xl leading-tight text-background-50 md:text-6xl">
            围观最热闹的
            <span className="text-accent-400">玩梗现场</span>
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            糖心吃瓜官网汇总糖心吃瓜热评、弹幕、名场面与群聊高能片段。梗图、神评、接梗不断，
            来这里跟网友一起刷屏玩梗不冷场。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#ranking"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line" aria-hidden="true" />
              逛今日热榜
            </a>
            <a
              href="#scenes"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-star-smile-line" aria-hidden="true" />
              看名场面
            </a>
            <Link
              to="/topics"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 py-3 text-sm text-background-200 transition-colors hover:text-background-50"
            >
              按分类找梗
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <dl className="mt-10 grid max-w-2xl grid-cols-3 gap-4 md:gap-8">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs text-background-300 md:text-sm">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl text-accent-300 md:text-4xl">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="border-t border-background-50/15 bg-black/35 py-3 backdrop-blur-sm">
          <div className="flex items-center gap-3 px-4 md:px-6">
            <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs text-accent-300 md:text-sm">
              <i className="ri-live-line" aria-hidden="true" />
              弹幕实时
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="marquee-track flex w-max items-center gap-6">
                {tickerItems.map((item, index) => (
                  <span
                    key={`${item}-${index}`}
                    className="whitespace-nowrap text-xs text-background-200 md:text-sm"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}